import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { useTranslation } from 'react-i18next';

const WIDTH = 360;
const HEIGHT = 240;

interface IRoadsDegradationProps {
  value?: string;
  duration?: string;
}

const RoadsDegradationChart: React.FC<IRoadsDegradationProps> = () => {
  const { t } = useTranslation();

  const seriesData = [
    {
      name: t('screens:assetsHome.rci'),
      type: 'line',
      data: [70, 57, 62, 74, 70, 45, 60, 80, 96, 77, 54, 40],
    },
    {
      name: t('screens:assetsHome.normal'),
      type: 'area',
      data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
    },
    {
      name: t('screens:assetsHome.moderate'),
      type: 'area',
      data: [60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60],
    },
    {
      name: t('screens:assetsHome.degraded'),
      type: 'area',
      data: [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20],
    },
    {
      name: t('screens:assetsHome.critical'),
      type: 'area',
      data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: 'line',
      fontFamily: 'Poppins',
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: false,
      },
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
    },
    labels: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
    stroke: {
      show: true,
      curve: 'smooth',
      width: [4, 0],
    },
    title: {
      floating: true,
      align: 'center',
      offsetX: 14,
      style: {
        fontWeight: 700,
        fontFamily: 'Poppins',
        fontSize: '16px',
      },
    },
    xaxis: {
      type: 'category',
      labels: {
        show: true,
      },
    },
    yaxis: {
      axisBorder: {
        show: true,
      },
      title: {
        text: `${t('screens:assetsHome.roadConditionIndex')} (${t(
          'screens:assetsHome.rci',
        )})`,
        style: {
          fontWeight: 500,
          fontFamily: 'Poppins',
        },
      },
      max: 100,
      min: 0,
      tickAmount: 4,
    },
    plotOptions: {
      area: {
        fillTo: 'end',
      },
    },
    legend: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
    fill: {
      type: 'solid',
    },
    colors: ['#7030A0', '#BDE6CB', '#F3F3C0', '#F5E2BF', '#F4C8C8'],
  };

  return (
    <div
      style={{
        width: WIDTH,
        height: HEIGHT,
      }}
    >
      <Chart options={options} series={seriesData} type="line" />
    </div>
  );
};

export default RoadsDegradationChart;
